import { render, staticRenderFns } from "./PhoneSettingWidget.vue?vue&type=template&id=f85bec62&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PhoneSettingWidget.vue?vue&type=script&lang=js&"
export * from "./PhoneSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSettingWidget.vue?vue&type=style&index=0&id=f85bec62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85bec62",
  null
  
)

export default component.exports